module.exports = __webpack_public_path__ + "assets/89c2c577001ae8ce6df7e42258d9778d.ttf";